import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Video } from "@circle-react-shared/Video/index";

export interface DisplayMediaProps {
  hasContent?: boolean;
  isVideo?: boolean;
  mediaURL: string;
}

export const DisplayMedia = ({
  hasContent = false,
  isVideo = false,
  mediaURL,
}: DisplayMediaProps) => {
  if (isVideo) {
    return (
      <div className="welcome-banner__video">
        <div className="video-content">
          <Video url={mediaURL} shouldDisableDownload />
        </div>
      </div>
    );
  }

  return (
    <div className="welcome-banner__image">
      <div className="image-content">
        <img
          loading="lazy"
          alt=""
          className={classNames("rounded-none", {
            "lg:rounded-t-2xl": hasContent,
            "lg:rounded-2xl": !hasContent,
          })}
          src={mediaURL}
          data-testid="welcome-media-content"
        />
      </div>
    </div>
  );
};
